/*
  StoveSource: hide gallery photos that belong to a different color/finish/trim.
  A photo belongs to an option value when every word of that value appears in the
  photo's alt text. When a photo names several values (e.g. "Black" and
  "Black Stainless Trim"), only the most specific one counts. Photos that name no
  value (remote, control panel, dimensions) stay visible for every option.
*/
(function () {
  if (window.ssVariantMediaFilterLoaded) return;
  window.ssVariantMediaFilterLoaded = true;

  const words = (s) =>
    (s || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, ' ')
      .trim()
      .split(' ')
      .filter(Boolean);

  function valuesNamedIn(alt, values) {
    const altWords = new Set(words(alt));
    const hits = values.filter((v) => {
      const w = words(v);
      return w.length && w.every((x) => altWords.has(x));
    });
    return hits.filter(
      (h) =>
        !hits.some((o) => {
          if (o === h) return false;
          const ow = new Set(words(o));
          const hw = words(h);
          return hw.length < ow.size && hw.every((x) => ow.has(x));
        })
    );
  }

  function apply(sectionId, selectedOptions) {
    const cfgEl = document.getElementById(`SSVariantMediaFilter-${sectionId}`);
    if (!cfgEl || !selectedOptions) return;
    let cfg;
    try {
      cfg = JSON.parse(cfgEl.textContent);
    } catch (e) {
      return;
    }
    const gallery = document.getElementById(`MediaGallery-${sectionId}`);
    if (!gallery) return;

    const items = gallery.querySelectorAll('.product__media-list > li, .thumbnail-list > li');
    items.forEach((li) => {
      const img = li.querySelector('img');
      const alt = img ? img.getAttribute('alt') : '';
      let hide = false;
      cfg.options.forEach((opt) => {
        const selected = selectedOptions[opt.index];
        if (!selected) return;
        const named = valuesNamedIn(alt, opt.values);
        if (named.length && !named.includes(selected)) hide = true;
      });
      li.classList.toggle('ss-media-hidden', hide);
    });

    gallery.querySelector('slider-component[id^="GalleryViewer"]')?.resetPages?.();
    gallery.querySelector('slider-component[id^="GalleryThumbnails"]')?.resetPages?.();
  }

  function selectedFromPage(sectionId) {
    const el = document.querySelector(
      `#MainProduct-${sectionId} variant-selects [data-selected-variant], product-info[data-section="${sectionId}"] variant-selects [data-selected-variant]`
    );
    if (!el) return null;
    try {
      return JSON.parse(el.textContent).options;
    } catch (e) {
      return null;
    }
  }

  function init() {
    document.querySelectorAll('script[id^="SSVariantMediaFilter-"]').forEach((el) => {
      const sectionId = el.id.replace('SSVariantMediaFilter-', '');
      apply(sectionId, selectedFromPage(sectionId));
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const data = event && event.data;
        if (!data || !data.variant) return;
        setTimeout(() => apply(data.sectionId, data.variant.options), 50);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
